import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {
	makeGetMockedRefundProtocolStatus,
	makeGetRefundProtocolStatus,
} from 'main/factories/usecases/private/refund/consult-refunds/get-refund-protocol-status';
import {getRefundProtocolStatus} from './utils/getRefundProtocolStatus';

const useProtocolStatus = (protocolCode: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONSULT_REFUND_PROTOCOL_STATUS, protocolCode],
		queryFn: ({signal}) =>
			getRefundProtocolStatus(makeGetRefundProtocolStatus()).perform({protocolCode, signal}),
		retry: 2,
		enabled: Boolean(protocolCode),
	});

const useMockedProtocolStatus = (protocolCode: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.CONSULT_REFUND_PROTOCOL_STATUS, protocolCode],
		queryFn: () =>
			getRefundProtocolStatus(makeGetMockedRefundProtocolStatus()).perform({protocolCode}),
		enabled: Boolean(protocolCode),
	});

export {useProtocolStatus, useMockedProtocolStatus};
